import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Renderer.TropicalStormExt = function() {
  this.draw = function(layer, content, conf, context, style, data, revision, dl) {
    WRAP.Geo.check(layer, content, conf, context, style, data, revision, dl);

    var valid = true;
    if ( this.conf_revision != revision.conf ) {
      valid = false;
    }

    if ( this.style_revision != revision.style ) {
      valid = false;
    }

    if ( this.data_revision != revision.data ) {
      valid = false;
    }

    if ( valid )
      return;

    layer.setStatus({status:"invalid", reason:"data load waiting."});

    var root = data.retained.data;
    if ( !root ) {
      if ( data.status.index || data.status.data )
        layer.setStatus({status:"error", reason:"data load error."});
      return;
    }

    if ( data.status.data != 'completed' )
      layer.setStatus({status:"error", reason:"data load error."});

    var s = conf.Attributes;
    if ( s.show_forcast_track !== undefined )
      s.show_forecast_track = s.show_forcast_track;
    if ( s.show_forcast_wind_radii !== undefined )
      s.show_forecast_wind_radii = s.show_forcast_wind_radii;

    function drawLine(p, r1, r2, dir, line_color, line_width, f) {
      if ( !r1 && !r2 )
        return;
      var s = WRAP.Geo.getGCPoint(p, r1, dir);
      var e = WRAP.Geo.getGCPoint(p, r2, dir);
      var feature = new WRAP.Geo.Feature.GeoLine({
        path:[[s.lonDegree(),s.latDegree()],[e.lonDegree(),e.latDegree()]],
        strokeStyle:line_color,
        lineWidth:line_width
      });
      feature.geo = f;
      layer.addFeature(feature);
    }

    function drawWindSector(point, prop, f) {
      var factor = 1852;
      const offsetDeg = 0.05;
      var stmrds_gale_1  = prop.stmrds_gale_1  || 0;
      var stmrds_gale_2  = prop.stmrds_gale_2  || 0;
      var stmrds_gale_3  = prop.stmrds_gale_3  || 0;
      var stmrds_gale_4  = prop.stmrds_gale_4  || 0;
      var stmrds_storm_1 = prop.stmrds_storm_1 || 0;
      var stmrds_storm_2 = prop.stmrds_storm_2 || 0;
      var stmrds_storm_3 = prop.stmrds_storm_3 || 0;
      var stmrds_storm_4 = prop.stmrds_storm_4 || 0;
      var stmrds_hurricane_1 = prop.stmrds_hurricane_1 || 0;
      var stmrds_hurricane_2 = prop.stmrds_hurricane_2 || 0;
      var stmrds_hurricane_3 = prop.stmrds_hurricane_3 || 0;
      var stmrds_hurricane_4 = prop.stmrds_hurricane_4 || 0;
      var stmrda_gale_1  = prop.stmrda_gale_1  || 0;
      var stmrda_gale_2  = prop.stmrda_gale_2  || 0;
      var stmrda_gale_3  = prop.stmrda_gale_3  || 0;
      var stmrda_gale_4  = prop.stmrda_gale_4  || 0;
      var stmrda_storm_1 = prop.stmrda_storm_1 || 0;
      var stmrda_storm_2 = prop.stmrda_storm_2 || 0;
      var stmrda_storm_3 = prop.stmrda_storm_3 || 0;
      var stmrda_storm_4 = prop.stmrda_storm_4 || 0;
      var stmrda_hurricane_1 = prop.stmrda_hurricane_1 || 0;
      var stmrda_hurricane_2 = prop.stmrda_hurricane_2 || 0;
      var stmrda_hurricane_3 = prop.stmrda_hurricane_3 || 0;
      var stmrda_hurricane_4 = prop.stmrda_hurricane_4 || 0;
      var wind_line_color_gale      = s.wind_line_color_gale;
      var wind_line_color_storm     = s.wind_line_color_storm;
      var wind_line_color_hurricane = s.wind_line_color_hurricane;
      var wind_fill_color_gale      = s.wind_fill_color_gale;
      var wind_fill_color_storm     = s.wind_fill_color_storm;
      var wind_fill_color_hurricane = s.wind_fill_color_hurricane;

      var r_gale_1  = stmrds_gale_1*factor;
      var r_gale_2  = stmrds_gale_2*factor;
      var r_gale_3  = stmrds_gale_3*factor;
      var r_gale_4  = stmrds_gale_4*factor;
      var r_storm_1 = stmrds_storm_1*factor;
      var r_storm_2 = stmrds_storm_2*factor;
      var r_storm_3 = stmrds_storm_3*factor;
      var r_storm_4 = stmrds_storm_4*factor;
      var r_hurricane_1 = stmrds_hurricane_1*factor;
      var r_hurricane_2 = stmrds_hurricane_2*factor;
      var r_hurricane_3 = stmrds_hurricane_3*factor;
      var r_hurricane_4 = stmrds_hurricane_4*factor;

      if ( r_gale_1 ) {
        var feature = new WRAP.Geo.Feature.GeoArc({
          point:point,
          radius:r_gale_1,
          start:stmrda_gale_1,
          end:stmrda_gale_2 + offsetDeg,
          strokeStyle:wind_line_color_gale,
          lineWidth:s.wind_line_width,
          fillStyle:wind_fill_color_gale,
        });
        feature.geo = f;
        layer.addFeature(feature);
      }
      if ( r_gale_2 ) {
        var feature = new WRAP.Geo.Feature.GeoArc({
          point:point,
          radius:r_gale_2,
          start:stmrda_gale_2,
          end:stmrda_gale_3 + offsetDeg,
          strokeStyle:wind_line_color_gale,
          lineWidth:s.wind_line_width,
          fillStyle:wind_fill_color_gale,
        });
        feature.geo = f;
        layer.addFeature(feature);
      }
      if ( r_gale_3 ) {
        var feature = new WRAP.Geo.Feature.GeoArc({
          point:point,
          radius:r_gale_3,
          start:stmrda_gale_3,
          end:stmrda_gale_4 + offsetDeg,
          strokeStyle:wind_line_color_gale,
          lineWidth:s.wind_line_width,
          fillStyle:wind_fill_color_gale,
        });
        feature.geo = f;
        layer.addFeature(feature);
      }
      if ( r_gale_4 ) {
        var feature = new WRAP.Geo.Feature.GeoArc({
          point:point,
          radius:r_gale_4,
          start:stmrda_gale_4,
          end:stmrda_gale_1+360 + offsetDeg,
          strokeStyle:wind_line_color_gale,
          lineWidth:s.wind_line_width,
          fillStyle:wind_fill_color_gale,
        });
        feature.geo = f;
        layer.addFeature(feature);
      }

      var p = new WRAP.Geo.Point(point[1]*60.0, point[0]*60.0);
      drawLine(p, r_gale_1, r_gale_4, stmrda_gale_1, wind_line_color_gale, s.wind_line_width, f);
      drawLine(p, r_gale_1, r_gale_2, stmrda_gale_2, wind_line_color_gale, s.wind_line_width, f);
      drawLine(p, r_gale_2, r_gale_3, stmrda_gale_3, wind_line_color_gale, s.wind_line_width, f);
      drawLine(p, r_gale_3, r_gale_4, stmrda_gale_4, wind_line_color_gale, s.wind_line_width, f);

      if ( r_storm_1 ) {
        var feature = new WRAP.Geo.Feature.GeoArc({
          point:point,
          radius:r_storm_1,
          start:stmrda_storm_1,
          end:stmrda_storm_2,
          strokeStyle:wind_line_color_storm,
          lineWidth:s.wind_line_width,
          fillStyle:wind_fill_color_storm,
        });
        feature.geo = f;
        layer.addFeature(feature);
      }
      if ( r_storm_2 ) {
        var feature = new WRAP.Geo.Feature.GeoArc({
          point:point,
          radius:r_storm_2,
          start:stmrda_storm_2,
          end:stmrda_storm_3,
          strokeStyle:wind_line_color_storm,
          lineWidth:s.wind_line_width,
          fillStyle:wind_fill_color_storm,
        });
        feature.geo = f;
        layer.addFeature(feature);
      }
      if ( r_storm_3 ) {
        var feature = new WRAP.Geo.Feature.GeoArc({
          point:point,
          radius:r_storm_3,
          start:stmrda_storm_3,
          end:stmrda_storm_4,
          strokeStyle:wind_line_color_storm,
          lineWidth:s.wind_line_width,
          fillStyle:wind_fill_color_storm,
        });
        feature.geo = f;
        layer.addFeature(feature);
      }
      if ( r_storm_4 ) {
        var feature = new WRAP.Geo.Feature.GeoArc({
          point:point,
          radius:r_storm_4,
          start:stmrda_storm_4,
          end:stmrda_storm_1+360,
          strokeStyle:wind_line_color_storm,
          lineWidth:s.wind_line_width,
          fillStyle:wind_fill_color_storm,
        });
        feature.geo = f;
        layer.addFeature(feature);
      }

      drawLine(p, r_storm_1, r_storm_4, stmrda_storm_1, wind_line_color_storm, s.wind_line_width, f);
      drawLine(p, r_storm_1, r_storm_2, stmrda_storm_2, wind_line_color_storm, s.wind_line_width, f);
      drawLine(p, r_storm_2, r_storm_3, stmrda_storm_3, wind_line_color_storm, s.wind_line_width, f);
      drawLine(p, r_storm_3, r_storm_4, stmrda_storm_4, wind_line_color_storm, s.wind_line_width, f);

      if ( r_hurricane_1 ) {
        var feature = new WRAP.Geo.Feature.GeoArc({
          point:point,
          radius:r_hurricane_1,
          start:stmrda_hurricane_1,
          end:stmrda_hurricane_2,
          strokeStyle:wind_line_color_hurricane,
          lineWidth:s.wind_line_width,
          fillStyle:wind_fill_color_hurricane,
        });
        feature.geo = f;
        layer.addFeature(feature);
      }
      if ( r_hurricane_2 ) {
        var feature = new WRAP.Geo.Feature.GeoArc({
          point:point,
          radius:r_hurricane_2,
          start:stmrda_hurricane_2,
          end:stmrda_hurricane_3,
          strokeStyle:wind_line_color_hurricane,
          lineWidth:s.wind_line_width,
          fillStyle:wind_fill_color_hurricane,
        });
        feature.geo = f;
        layer.addFeature(feature);
      }
      if ( r_hurricane_3 ) {
        var feature = new WRAP.Geo.Feature.GeoArc({
          point:point,
          radius:r_hurricane_3,
          start:stmrda_hurricane_3,
          end:stmrda_hurricane_4,
          strokeStyle:wind_line_color_hurricane,
          lineWidth:s.wind_line_width,
          fillStyle:wind_fill_color_hurricane,
        });
        feature.geo = f;
        layer.addFeature(feature);
      }
      if ( r_hurricane_4 ) {
        var feature = new WRAP.Geo.Feature.GeoArc({
          point:point,
          radius:r_hurricane_4,
          start:stmrda_hurricane_4,
          end:stmrda_hurricane_1+360,
          strokeStyle:wind_line_color_hurricane,
          lineWidth:s.wind_line_width,
          fillStyle:wind_fill_color_hurricane,
        });
        feature.geo = f;
        layer.addFeature(feature);
      }

      drawLine(p, r_hurricane_1, r_hurricane_4, stmrda_hurricane_1, wind_line_color_hurricane, s.wind_line_width, f);
      drawLine(p, r_hurricane_1, r_hurricane_2, stmrda_hurricane_2, wind_line_color_hurricane, s.wind_line_width, f);
      drawLine(p, r_hurricane_2, r_hurricane_3, stmrda_hurricane_3, wind_line_color_hurricane, s.wind_line_width, f);
      drawLine(p, r_hurricane_3, r_hurricane_4, stmrda_hurricane_4, wind_line_color_hurricane, s.wind_line_width, f);
    }

    layer.clear();

    for ( var id in root ) {
      var geo = root[id];
      if ( !geo.features )
        continue;
      if ( geo.display_flag === false )
        continue;
      var track = [];
      var forecast = [];
      for ( var i = 0 ; i < geo.features.length ; i++ ) {
        var f = geo.features[i];
        var prop = f.properties;
        prop.id = id;
        var type = prop.wrap_feature_type;
        var point = f.geometry.coordinates;
        if ( type == 'track' )
          track.push(point);
        else if ( type == 'forecast' )
          forecast.push(point);
      }
      for ( var i = 0 ; i < geo.features.length ; i++ ) {
        var f = geo.features[i];
        var prop = f.properties;
        var type = prop.wrap_feature_type;
        var point = f.geometry.coordinates;
        if ( type == 'analysis' ) {
          track.push(point);
          forecast.unshift(point);
        }
      }

      var active_type = ['analysis'];

      if ( s.show_track_history === undefined || s.show_track_history === true ) {
        active_type.push('track');
        var feature = new WRAP.Geo.Feature.GeoLine({
          path:track,
          strokeStyle:s.track_history_line_color,
          lineWidth:s.track_history_line_width
        });
        layer.addFeature(feature);
      }
      if ( s.show_forecast_track === undefined || s.show_forecast_track === true ) {
        active_type.push('forecast');
        var feature = new WRAP.Geo.Feature.GeoLine({
          path:forecast,
          strokeStyle:s.forecst_track_line_color,
          lineWidth:s.forecst_track_line_width
        });
        layer.addFeature(feature);
      }

      var rollback_feature = null;
      if ( !s.track_circle_time ) {
        if ( s.show_analysis_wind_radii === undefined || s.show_analysis_wind_radii === true ) {
          for ( var i = 0 ; i < geo.features.length ; i++ ) {
            var f = geo.features[i];
            var prop = f.properties;
            if ( prop.wrap_feature_type == 'analysis' ) {
              var point = f.geometry.coordinates;
              drawWindSector(point, prop, f);
            }
          }
        }
        if ( s.show_forecast_track === undefined || s.show_forecast_track === true ) {
          if ( s.show_forecast_wind_radii === undefined || s.show_forecast_wind_radii === true ) {
            for ( var i = 0 ; i < geo.features.length ; i++ ) {
              var f = geo.features[i];
              var prop = f.properties;
              if ( prop.wrap_feature_type == 'forecast' ) {
                var point = f.geometry.coordinates;
                drawWindSector(point, prop, f);
              }
            }
          }
        }
      }
      else {
        var ct = new WRAP.Core.DateTime(s.track_circle_time);
        var ld = Number.MIN_SAFE_INTEGER;
        for ( var i = 0 ; i < geo.features.length ; i++ ) {
          var f = geo.features[i];
          var prop = f.properties;
          if ( prop.valid ) {
            var d = ct.diff(new WRAP.Core.DateTime(prop.valid));
            if ( d <= 0 && ld < d ) {
              ld = d;
              rollback_feature = f;
            }
          }
        }
        if ( rollback_feature ) {
          var point = rollback_feature.geometry.coordinates;
          var prop = rollback_feature.properties;
          drawWindSector(point, prop);
        }
      }

      if ( s.show_datetime === undefined || s.show_datetime === true ) {
        for ( var i = 0 ; i < geo.features.length ; i++ ) {
          var f = geo.features[i];
          var prop = f.properties;
          if ( active_type.indexOf(prop.wrap_feature_type) < 0 )
            continue;
          if ( !s.track_circle_time ) {
            if ( prop.wrap_feature_type == 'track' )
              continue;
          }
          else {
            if ( f != rollback_feature )
              continue;
          }
          var date = prop.valid;
          if ( date && date.length >= 11 ) {
            var text = "";
            var date_format_bylocale = s.date_format_bylocale;
            var date_format = s.date_format;
            if (date_format_bylocale) {
              const wdate = new WRAP.Core.DateTime(date);
              if(date_format_bylocale.indexOf('z[Z]')) {
                text = wdate.format(date_format_bylocale.replace('z[Z]', 'z'), WRAP.Core.timezone);
                if (text)
                  text = text.replace(' UTC', 'Z');
              } else {
                text = wdate.format(date_format_bylocale, WRAP.Core.timezone);
              }
            } else if ( date_format ) {
              var u_year = 0, u_mon = 0, u_day = 0, u_hour = 0, u_min = 0, u_sec = 0;
              u_year = parseInt(date.substr(0,4));
              u_mon = parseInt(date.substr(4,2));
              u_day = parseInt(date.substr(6,2));
              u_hour = parseInt(date.substr(9,2));
              u_min = parseInt(date.substr(11,2));
              if ( date.length >= 13 )
                u_sec = parseInt(date.substr(13,2));
              text = WRAP.Geo.formatTime(date_format, u_year, u_mon, u_day, u_hour, u_min, u_sec);
            }
            else {
              text = date.substr(6,2);
              text += " / ";
              text += date.substr(9,2);
              text += "Z";
            }
            var font_size = s.label_font_size || 12;
            var point = f.geometry.coordinates;
            var feature = new WRAP.Geo.Feature.Text({
              text:text,
              point:point,
              strokeStyle:s.label_edge_color,
              fillStyle:s.label_text_color,
              offsetX:s.label_offset_x,
              offsetY:s.label_offset_y,
              align:'left',
              fontSize:font_size
            });
            feature.geo = f;
            layer.addFeature(feature);
          }
        }
      }
      for ( var i = 0 ; i < geo.features.length ; i++ ) {
        var f = geo.features[i];
        var prop = f.properties;
        if ( active_type.indexOf(prop.wrap_feature_type) < 0 )
          continue;
        //if ( prop.wrap_feature_type == 'analysis' && active_type.length == 1 )
        //  continue;
        var type = prop.class;
        var point = f.geometry.coordinates;

        var icon = s.icon[type];
        if ( s.icon[prop.wrap_feature_type] ) {
          if ( s.icon[prop.wrap_feature_type].icon )
            icon = s.icon[prop.wrap_feature_type].icon;
          if ( s.icon[prop.wrap_feature_type].class_icon && s.icon[prop.wrap_feature_type].class_icon[type] )
            icon = s.icon[prop.wrap_feature_type].class_icon[type];
        }
        if ( point[1] < 0 && s.icon_south ) {
          if ( s.icon_south[type] )
            icon = s.icon_south[type];
          if ( s.icon_south[prop.wrap_feature_type] ) {
            if ( s.icon_south[prop.wrap_feature_type].icon )
              icon = s.icon_south[prop.wrap_feature_type].icon;
            if ( s.icon_south[prop.wrap_feature_type].class_icon && s.icon_south[prop.wrap_feature_type].class_icon[type] )
              icon = s.icon_south[prop.wrap_feature_type].class_icon[type];
          }
        }
        if ( s.custom_icon_time && s.custom_icon ) {
          if ( (prop.wrap_feature_type == 'analysis' && s.custom_icon_time == prop.wrap_feature_type)
            || prop.valid == s.custom_icon_time )
            icon = s.custom_icon;
        }
        if ( icon ) {
          var feature = new WRAP.Geo.Feature.Image({
            image:icon,
            point:point,
            width:s.icon_width,
            height:s.icon_height,
            offsetX:s.icon_offset_x,
            offsetY:s.icon_offset_y,
          });
          feature.geo = f;
          layer.addFeature(feature);
        }
      }
    }

    this.conf_revision = revision.conf;
    this.style_revision = revision.style;
    this.data_revision = revision.data;
    if ( layer.getStatus().status != 'error' )
      layer.setStatus({status:"valid"});
    WRAP.Geo.invalidate();
  }
};
/* eslint-enable */